import {
    InputText,
    InputPassword,
    InputPhone,
    InputNumber,
    InputPrice,
    FormikAsyncSelect,
    FormikInputCheckbox,
    FormikDateInput,
    FormikTimeInput,
    FormikTextArea
} from "./Fields";
import ImageFile from "./ImageFile";
import Days from "./Days";


const FIELDS = {
    text: InputText,
    number: InputNumber,
    price: InputPrice,
    password: InputPassword,
    phone: InputPhone,
    checkbox: FormikInputCheckbox,
    textarea: FormikTextArea,
    asyncSelect: FormikAsyncSelect,
    image: ImageFile,
    days: Days,
    date: FormikDateInput,
    time: FormikTimeInput
};

export const getField = fieldType => {
    if (FIELDS.hasOwnProperty(fieldType)) {
        return FIELDS[fieldType]
    } else {
        return FIELDS.text
    }
};